import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user.service';
import { Scope } from 'src/app/shared/enum/scope.enum';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})

export class ToolbarComponent implements OnInit {

  public scope: typeof Scope = Scope;
  public username: string = '';

  constructor(
    private _router: Router,
    private _authService: AuthService,
    private _userService: UserService,
    public sidebarService: SidebarService,
    ) {
      this.username = this._userService.getCurrentUser()?.name + ' ' + this._userService.getCurrentUser()?.surname;
  }

  ngOnInit() { }

  public isAuthorized(scopes : Scope[]) {
    if(scopes.length > 0) {
      return this._authService.hasRight(scopes)
    }
    return false;
  }

  public logout() {
    this._authService.logout();
    this._router.navigate(['login']);
  }

  public isCompanyAdmin() {
    return this._authService.isCompanyAdmin();
  }

}
